
    const data = {"name":"src/core/icons/window-close","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13.46 12 19 17.54V19h-1.46L12 13.46 6.46 19H5v-1.46L10.54 12 5 6.46V5h1.46L12 10.54 17.54 5H19v1.46L13.46 12Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            